import type { ComponentProps } from "react";

import { Navbar } from "@/covaltech-react-ui";

import NavLogout from "./NavLogout";

type AppNavbarProps = Omit<ComponentProps<typeof Navbar>, "children">;

const AppNavbar = (props: AppNavbarProps) => {
  return (
    <Navbar {...props}>
      <NavLogout />
    </Navbar>
  );
};

export default AppNavbar;
